import React from "react";
import AppLayout from "components/AppLayout";
import Header from "components/Header";
import BoardPage from "pages/BoardPage";
import DbmsPage from "pages/DbmsPage";
import FireOnPage from "pages/FireOnPage";
import { Navigate, Route, Routes } from "react-router-dom";

export default function Main() {
  return (
    <AppLayout header={<Header />}>
      <Routes>
        <Route path="/board/*" element={<BoardPage />}></Route>
        <Route path="/fire-on/*" element={<FireOnPage />} dark={true}></Route>
        <Route path="/dbms/*" element={<DbmsPage />} black={true}></Route>
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </AppLayout>
  );
}
